export default {
  namespaced: true,
  name: 'SLSRepresentanteStore',
  state: {
    representantes: [],
    selectedRepresentante: null,
    loading: false,
    filters: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      representanteid: null,
      representantenome: null,
    },
  },
  mutations: {
    SET_REPRESENTANTES(state, payload) {
      state.representantes = payload;
    },
    SET_REPRESENTANTES_E_PAGINACAO(state, { data, pagination }) {
      state.representantes = data;
      state.pagination = pagination;
      state.filters.total = pagination.total;
    },
    SET_FILTERS_REPRESENTANTE_ID(state, payload) {
      state.filters.representanteid = payload;
    },
    SET_FILTERS_REPRESENTANTE_NOME(state, payload) {
      state.filters.representantenome = payload;
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_SELECTED_REPRESENTANTE(state, payload) {
      state.selectedRepresentante = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = { ...state.filters, ...payload };
    },
    SET_FILTERS_PER_PAGE(state, payload) {
      state.filters.perPage = payload;
    },
  },
  getters: {
    representantes: (state) => state.representantes,
    selectedRepresentante: (state) => state.selectedRepresentante,
    loading: (state) => state.loading,
    filters: (state) => state.filters,

  },
  actions: {
    resertFilters({ commit }) {
      commit('SET_FILTERS', {
        page: 1,
        perPage: 8,
        sortBy: null,
        sortDesc: null,
        representanteid: null,
        representantenome: null,
      });
    },
  },
};
